<template>
  <div v-if="$store.state.isLogged === false" class="row window-height justify-center items-center backimage">
    <div class="col-md-4 col-xs-12 col-sm-12">
      <q-form @submit="onSubmit" @reset="onReset">
        <q-card class="my-card q-ma-xs q-ma-md">
          <q-card-section class="bg-primary text-white">
            <div>
              <span>{{ $store.state.appTitle }}</span>
              <q-badge color="red" align="top" class="q-ml-sm" :label="$store.state.appVersion"/>
            </div>
          </q-card-section>
          <q-card-section class="row justify-center items-center">
            <img alt="nooran logo" src="@/assets/logo.png" style="height: 150px;width: 150px"/>
          </q-card-section>
          <q-card-section class="q-pt-none">
            <q-input
                :dense="$q.screen.lt.md"
                v-model="loginInfo.username" label="نام کاربری"
                :rules="[ val => val && val.length > 0 || 'نام کاربری را وارد نمایید']"
                autofocus
                dir="ltr"
                filled autocomplete>
              <template v-if="loginInfo.username" v-slot:append>
                <q-icon name="cancel" @click.stop="loginInfo.username = null" class="cursor-pointer"/>
              </template>
            </q-input>
            <q-input v-model="loginInfo.password"
                     :dense="$q.screen.lt.md"
                     :rules="[ val => val && val.length > 0 || 'کلمه عبور خود را وارد نمایید']"
                     :type="isPwd ? 'password' : 'text'" filled dir="ltr" autocomplete>
              <template v-slot:append>
                <q-icon
                    :name="isPwd ? 'visibility_off' : 'visibility'"
                    class="cursor-pointer"
                    @click="isPwd = !isPwd"
                />
              </template>
              <template v-if="loginInfo.password" v-slot:append>
                <q-icon name="cancel" @click.stop="loginInfo.password = null" class="cursor-pointer"/>
              </template>
            </q-input>
          </q-card-section>
          <q-separator/>
          <q-card-actions align="center">
            <q-btn type="submit" color="indigo" icon="login">ورود به سامانه</q-btn>
          </q-card-actions>
        </q-card>
      </q-form>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex"

export default {
  name: "login",
  data() {
    return {
      isPwd: true,
      loginInfo: {
        username: null,
        password: null
      }
    }
  },
  methods: {
    ...mapActions({
      login: "Authenticate/login",
    }),
    onSubmit() {
      this.login({
        username: this.loginInfo.username.trim(),
        password: this.loginInfo.password.trim()
      }).then((res) => {
        if (res.status === 200) {
          this.$store.state.isLogged = true;
          if (this.$store.state.roles.some(v => ['admin'].includes(v))) {
            this.$router.push("/sell_buy_order_trace")
          } else if (this.$store.state.roles.some(v => ['user_purchase'].includes(v)) && this.$store.state.roles.some(v => ['user_sell'].includes(v))) {
            this.$router.push("/sell_buy_order_trace")
          }else if (this.$store.state.roles.some(v => ['user_purchase'].includes(v))) {
            this.$router.push("/buy_order_trace")
          } else if (this.$store.state.roles.some(v => ['user_sell'].includes(v))) {
            this.$router.push("/order-trace")
          } else if (this.$store.state.roles.some(v => ['user_store'].includes(v))) {
            this.$router.push("/my")
          } else if (this.$store.state.roles.some(v => ['user_visitor'].includes(v)) && !this.$store.state.roles.some(v => ['can_see_all_trace_orders'].includes(v))) {
            this.$router.push("/my_order_list").catch(() => {
            })
          } else {
            this.$router.push("/order-trace")
          }
        }
      }).catch((error) => {
        if (error.toString().includes('Error: Network Error') === false) {
          this.$q.notify({
            message: 'نام کاربری و یا کلمه عبور شما صحیح نمی باشد',
            color: 'red',
            position: 'top',
            type: 'negative'
          });
        }
      });
    },
    onReset() {
      this.loginInfo.username = null
      this.loginInfo.password = null
    }
  },
  meta() {
    return {
      title: this.$store.state.appTitle
    }
  }
}
</script>

<style scoped>
.backimage {
  background: url('https://picsum.photos/seed/picsum/1920/1080') no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>
